module.exports = __webpack_public_path__ + "img/index10.82db8b45.jpg";